const categories = [
  "道路・河川管理",
  "農地・農業用施設管理",
  "災害発生状況管理"
];

const sections = ["通常点検", "防災活動", "その他"];

const statuses = ["未対応", "対応中", "完了"];

const icons = [
  "mdi-road",
  "mdi-landslide",
  "mdi-home-flood",
  "mdi-close-octagon",
  "mdi-map-marker",
  "mdi-circle",
  "mdi-pentagon",
  "mdi-label",
  "mdi-check-circle",
  "mdi-circle-slice-8",
  "mdi-cloud",
  "mdi-message",
  "mdi-flash",
  "mdi-umbrella",
  "mdi-water",
  "mdi-alert-circle",
  "mdi-camera",
  "mdi-face-man"
];

export const Chronology = { categories, sections, statuses, icons };
